<template>
  <div>
    <template>
      <div class="">
        <AccordionHeader
          title="Data Collection"
          :isAccordionOpen="isAccordionOpen"
          @onToggleView="isAccordionOpen = !isAccordionOpen"
          :isDisabled="isDisabled"
          :borderStyles="
            isAccordionOpen
              ? `border-bottom: 1px solid #232220; border-top: 1px solid #232220;`
              : 'border-top: 1px solid #232220;'
          "
        />

        <section
          class="accordion-body"
          :class="{
            active: isAccordionOpen
          }"
        >
          <!-- data region -->
          <div class="title-container custom-block">
            <div class="title">
              <p><strong>Required information</strong></p>
            </div>
            <div class="detail">
              <span class="detail-info">
                The following information will be collected from users. These
                fields are required to ship out their package successfully.
              </span>

              <div class="required-fields">
                <div class="row">
                  <div class="row-holder first">
                    <div div class="field">&#8226; Work email</div>
                    <div class="field">&#8226; Full name</div>
                    <div class="field">&#8226; Company</div>
                  </div>

                  <div class="row-holder">
                    <div class="field">&#8226; Phone number</div>
                    <div class="field">&#8226; Shipping Address</div>
                    <div class="field">&#8226; City</div>
                  </div>

                  <div class="row-holder">
                    <div class="field">&#8226; State / Province</div>
                    <div class="field">&#8226; Zip Code</div>
                    <div class="field">&#8226; Country</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="title margin-top-2">
              <p><strong>Additional information</strong></p>
            </div>
            <div class="detail">
              <span class="detail-info">
                Add custom fields based on your company needs e.g. Employee ID,
                Office location or Team name.
              </span>
            </div>
            <div class="custom-fields">
              <form
                @submit.prevent
                :class="{ padded: !!groupOrderDetails.customFields.length }"
              >
                <div
                  class="form-group"
                  v-for="field in groupOrderDetails.customFields"
                  :key="field.name"
                >
                  <input
                    readonly
                    autocomplete="off"
                    placeholder="Type field name e.g. Location"
                    type="text"
                    class="form-control custom-input"
                    v-model="field.name"
                  />
                </div>
                <div
                  class="form-group"
                  v-for="(field, index) in customFields"
                  :key="index"
                >
                  <input
                    autocomplete="off"
                    placeholder="Type field name e.g. Location"
                    type="text"
                    class="form-control custom-input"
                    v-model="field.name"
                  />
                </div>
              </form>
              <div
                class="add-field"
                :class="{ disabled: groupOrderDetails.state === 'finalized' }"
              >
                <button
                  class="button-gemnote button-gemnote--small custom-button"
                  @click.prevent="addCustomField"
                >
                  <span>+ Add custom field</span>
                </button>
              </div>
            </div>
          </div>
          <input
            type="text"
            ref="dataCollectionHiddenRef"
            class="hidden-input"
          />
        </section>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AccordionHeader from '../AccordionHeader'
export default {
  name: 'DataCollection',
  props: ['isDisabled'],
  data() {
    return {
      customFields: [],
      isAccordionOpen: false
    }
  },

  components: {
    AccordionHeader
  },
  methods: {
    addCustomField() {
      this.customFields.push({ name: '', type: 'text' })
    },

    updateGroupOrder() {
      this.$store.dispatch('groupOrder/updateGroupOrder', {
        customFields: [
          ...this.groupOrderDetails.customFields,
          ...this.customFields
        ],
        redirect: false
      })
    },
    handleBlur() {
      this.updateGroupOrder()
    },
    toggleAccordion() {
      this.isAccordionOpen = !this.isAccordionOpen
    },
    setAccordion(value) {
      this.isAccordionOpen = value
    },
    onFocusInput() {
      this.$refs.dataCollectionHiddenRef.focus()
    }
  },
  computed: {
    ...mapState({
      groupOrderDetails: state => state.groupOrder.groupOrderDetails
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.margin {
  margin-bottom: 1.5rem;
}

.custom-input {
  font-size: 0.813rem !important;
}

.accordion-body {
  height: 0px;
  opacity: 0;
  &.active {
    height: max-content;
    opacity: 1;
    margin-top: 1.7rem;
    margin-bottom: 0.3rem;
  }
}

.holder {
  text-align: left;

  h3 {
    font-size: 1.063rem;
    font-family: $inter;
    color: $main-6;
    padding-bottom: 2rem;
    padding-top: 0.5rem;

    span {
      font-weight: 400;
    }
  }
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.header-region {
  margin: 2.5rem 0;
  border-bottom: 8px solid $main-6;
  p {
    text-align: center;
    padding-bottom: 0.6rem;
    font-size: 1.3rem;
    font-weight: 400;
  }
}

h4 {
  text-align: left;
}
.info-container {
  margin-top: 1.25rem;
  border: 1px solid #232220;
  padding-bottom: 1rem;
}

.domain-container,
.password-container,
.description-container,
.title-container {
  margin: 0rem 0;
  padding: 0 3rem 1rem 3rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding: 0 1rem 1rem 1rem;
  }
  .title {
    width: 100%;
    text-align: left;

    p {
      font-size: 0.913rem !important;
    }
  }

  .detail {
    width: 100%;
    .subheading {
      margin-bottom: 1rem;
    }
    p {
      text-align: left;
      font-size: 0.875rem;
      line-height: 24px;
    }
    .detail-info {
      font-size: 0.713rem;
      text-align: left;
      width: 100%;
      display: block;
      margin: 0.25rem 0 1rem 0;
      color: #514d43;
      font-weight: 300;
      line-height: 22px;
    }
  }
}

.required-fields {
  width: 80%;
}

.customize-section {
  display: flex;
  gap: 1.5rem;
  margin-top: 19px;
  &.password {
    grid-template-columns: 9.5rem 1fr;
    margin-top: 8px;
  }
  .radio-holder {
    width: max-content;
    height: 28px;
    display: flex;
    /* align-items: center; */

    &.password {
      margin-top: 0.5rem;
    }
  }

  &.special-instruction {
    grid-template-columns: 100% 1fr !important;
  }

  .input-holder {
    width: 64%;
  }

  .input-info-holder {
    width: 100%;
    .characters-info {
      width: max-content;
    }
    .error-text {
    }
  }

  .characters-info {
    display: block;
    position: relative;
    top: 0px;
    color: rgba(35, 34, 32, 0.5);
    font-size: 0.625rem;
    width: 80%;
    max-width: 90%;
    text-align: right;
  }

  ::placeholder {
    color: #9b9b9b;
    font-size: 0.75rem;
  }
  .error-text {
    color: #da5737;
    font-size: 10px;
  }
}
.row {
  display: flex;
  text-align: left;
  flex-wrap: wrap;
  justify-content: space-between;

  .row-holder {
    width: 33.3%;
    &.first {
      width: 25%;
    }
  }
}

.field {
  font-weight: 700;
  margin: 0.5rem 0;
  font-size: 0.813rem;
}
.custom-fields {
  form {
    width: 50%;
    text-align: left;
    margin-bottom: 0.5rem;
    input::placeholder {
      font-size: 0.813rem;
      color: #a09c95;
    }
    &.padded {
      margin-top: 0.5rem;
    }

    .form-group {
      display: flex;
      align-items: flex-end;
      gap: 1rem;
    }
  }

  .remove {
    cursor: pointer;
    display: block;
    width: 20px;
    user-select: none;
  }
}

.add-field {
  text-align: left;
  margin-bottom: 1.75rem;
  .button-gemnote--small {
    border: 1px solid #232220;
    height: 2.175rem;
    text-transform: unset;
    padding: 0px 2rem !important;
    font-weight: 400;
    width: auto;

    &.custom-button {
      background: #dfdad2;
      color: $onyx;
      text-transform: uppercase;
    }
  }
}

.button-area {
  margin-top: 3rem;
  display: flex;
  justify-content: center;

  button {
    padding: 0 2rem !important;
    width: auto;
    height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.domain-content {
  grid-gap: 1rem;
  p {
    margin-top: 0.8rem;
    text-align: left;
  }
}
.allow-domains {
  width: 100%;
}

.title p {
  font-size: 0.913rem;
}

.detail p {
  font-size: 0.813rem !important;
}

@media (max-width: 1100px) {
  .required-info {
    flex-direction: column;
    padding: 2rem;
    transition: 1s ease-in;

    .title {
      width: 100%;
      p {
        margin-bottom: 1rem;
      }
    }

    .detail {
      width: 100%;
    }
  }

  .aditional-info {
    flex-direction: column;
    padding: 2rem;
    transition: 1s ease-in;

    .title {
      width: 100%;
      p {
        margin-bottom: 1rem;
      }
    }

    .detail {
      width: 100%;
    }
  }

  .field {
    flex-basis: 50%;
  }

  .row {
    .row-holder {
      width: 100%;
      &.first {
        width: 100%;
      }
    }
  }
}

.hidden-input {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0px;
  height: 0px;
  opacity: 0;
}

@media (max-width: 800px) {
  .customize-section {
    display: block;
  }
  .custom-block {
    display: block;
  }
  .detail {
    width: 100% !important;
  }
  .domain-container {
    display: block;
  }
  .customize-section .password-holder {
    width: 100%;
  }
}
</style>
